import defaultImage from "../../assets/empty-favorites.png";

// Usa l'immagine dalla variabile d'ambiente se disponibile, altrimenti usa l'immagine di default
const getImagePath = () => {
  const envImage = import.meta.env.VITE_APP_IMAGE_FAVORITES;
  if (envImage) {
    // Importa dinamicamente l'immagine dalla cartella assets
    try {
      return new URL(`../../assets/${envImage}`, import.meta.url).href;
    } catch {
      return defaultImage;
    }
  }
  return defaultImage;
};

const image = getImagePath();

/* eslint-disable max-len */
export const Default = {
  coverPublicURL: image,
  shortDescription: "contents_explore",
  title: "favourites_empty"
};

export const HeroCardBookmarkVariants = {
  $topImageVisible: true,
  coverPublicURL: image,
  shortDescription: "contents_explore",
  title: "favourites_empty"
};

export const HeroCardHomeVariants = {
  $topImageVisible: true,
  coverPublicURL: image,
  shortDescription: "homepage_empty_description",
  title: "homepage_empty"
};

/* eslint-enable max-len */
